module.exports = "<span class=\"sorting\" [ngClass]=\"{'sorting_asc': direction === 'asc', 'sorting_desc': direction === 'desc'}\" (click)=\"sort()\"></span>\n"